import * as React from 'react';
import { Progress } from 'reactstrap';
import './NavMenu.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export default function LoadingCmp(props: any) {
  return (
    <Progress style={{ height: '3px', borderRadius: 0, backgroundColor: '#e5e7eb' }} animated color="primary" value={100} />
  );
}
